module.exports = __webpack_public_path__ + "static/media/assignred.eb5078c4.svg";